import { Injectable } from '@angular/core';
import { BackgroundColorOptions, StatusBar, StatusBarAnimation, StatusBarStyle } from '@capacitor/status-bar';
import { CurrentPlatformService } from '../current-platform/current-platform.service';

@Injectable({
  providedIn: 'root'
})
export class StatusBarService {

  isNative: boolean = false;

  constructor(
    private currentPlatformService: CurrentPlatformService
  ) {
    this.isNative = this.currentPlatformService.isNative();
  }

  hide(){
    if (this.isNative) StatusBar.hide({ animation: StatusBarAnimation.Slide });
  }

  show(){
    if (this.isNative) StatusBar.show({ animation: StatusBarAnimation.Slide });
  }

  barColorLight(){
    if (this.isNative) StatusBar.setStyle({style: StatusBarStyle.Light});
  }

  barColorDark(){
    if (this.isNative) StatusBar.setStyle({style: StatusBarStyle.Dark});
  }

  changeBGcolor(color){
    const opts: BackgroundColorOptions = { color: color }
    if (this.isNative) StatusBar.setBackgroundColor(opts)
  }

  toggleOverlays(){
    if (this.isNative) StatusBar.setOverlaysWebView({overlay: true});
  }
}
